














import {dirObj} from "@/store/type"
import {routerStore} from "@/store/routerStore"
import Icon from "./Icon.vue";
import { defineComponent, ref, computed, watch } from "@vue/composition-api";
import { shortName } from "@/utils/githubGraphQL";
interface Props {
  dir: dirObj;
}

export default defineComponent({
  name: "FolderItem",
  props: {
    dir: {}
  },
  components: {
    Icon
  },
  
  setup(props: Props) {
    const hide = ref(true);
    const pwd = computed(()=>routerStore.pwd)
    watch(pwd,(v) => hide.value = !v.includes(props.dir.path))  
    function go(path: string){
        routerStore.goto(path)
    }
    const final = computed(() => props.dir.file.length === 0);
    return {
      go,
      shortName,
      hide,
      final,
      toggle: () => {
        hide.value = !hide.value;
      }
    };
  }
});
